// src/Services/videochatSocket.js
//
// Socket global dedicado a la señalización de videochat (handshake +
// WebRTC in-call). Vive aparte de relaySocketRef/signalSocketRef de
// ChatScreen a propósito: esos dos son por-chat (se reconectan y se unen
// SOLO a la room del chat abierto cada vez que `selectedChatId` cambia,
// para el streaming en vivo) y morirían al navegar fuera del chat. Este
// socket es un singleton de toda la sesión, unido a todas las rooms de
// conversación del usuario (ver VideochatHost), así la solicitud de
// videochat suena sin importar en qué pantalla esté parado el usuario.
import { io } from 'socket.io-client'

const SOCKET_URL = 'wss://backend.yourpack.us'
const SOCKET_PATH = '/relay/'

let socket = null

// Handlers registrados antes de que el socket exista (o durante un logout que
// lo destruye). Se vuelven a enganchar en cada conexión nueva para que quien
// escuche notificaciones no dependa del orden de montaje de los componentes.
const pendingHandlers = new Map() // event -> Set(handler)

const bindHandler = (event, handler) => {
  if (socket) socket.on(event, handler)
}

export const getVideochatSocket = () => socket

export const safeOn = (event, handler) => {
  if (!pendingHandlers.has(event)) pendingHandlers.set(event, new Set())
  pendingHandlers.get(event).add(handler)
  bindHandler(event, handler)
}

export const safeOff = (event, handler) => {
  pendingHandlers.get(event)?.delete(handler)
  if (socket) socket.off(event, handler)
}

// El token no viaja en el handshake del socket — igual que los sockets
// per-chat existentes (relaySocketRef/signalSocketRef), la identidad/room
// se resuelve por `join(chatId)`, no por auth de socket.io. Solo se usa acá
// para decidir CUÁNDO conectar (con sesión iniciada).
export const connectVideochatSocket = (token) => {
  if (!token || socket) return socket
  socket = io(SOCKET_URL, {
    path: SOCKET_PATH,
    transports: ['websocket'],
    reconnection: true,
  })
  // Reenganchar los listeners registrados con safeOn antes de que existiera.
  pendingHandlers.forEach((handlers, event) => {
    handlers.forEach((handler) => socket.on(event, handler))
  })
  return socket
}

export const disconnectVideochatSocket = () => {
  if (!socket) return
  socket.removeAllListeners()
  socket.disconnect()
  socket = null
}
